import authGuard from '../router/guard';

export default {
  install: (app, options) => {
    // Init properties
    const { ApiService, initAuthGuard = true } = options
    const { globalProperties } = app.config
    const apiService = new ApiService(app) 

    // Create global plugin
    globalProperties.$apiService = () => {
      return apiService
    }

    if(!globalProperties.$store) {
      // Through error if no store but the connection to store is required
      if(initAuthGuard) throw new Error("No connected store was provided")
      return
    }

    // Connect global plugin to store
    globalProperties.$store.$apiService = globalProperties.$apiService;

    // Switch authGuard is required
    if(initAuthGuard) globalProperties.$router.beforeEach(authGuard(apiService.client, globalProperties.$store));
  }
}